// @ts-nocheck
import type * as Types from '../../../types/graphql/index';

import { gql } from '@apollo/client';
import { WorkspaceFragmentDoc } from '../../../graphql/current-user';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WorkspaceQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type WorkspaceQuery = { __typename?: 'Query', workspace: { __typename?: 'Workspace', id: string, created: number, name: string, timezone: string, stripeAccountConnected: boolean, nonprofitName: string, nonprofitTaxId: string, taxNote: string, taxFMVNote: string, website?: string | null, logoUrl?: string | null, verified: boolean, needsVerification: boolean, stripeAccountType?: Types.StripeAccountType | null, stripeAccountStatus: Types.StripeAccountStatus, needsStripeAccount: boolean, smsCampaignsEnabled: boolean, emailPopupEnabled: boolean, statementDescriptor?: string | null, googleAnalyticsId?: string | null, googleTagManagerId?: string | null, googleAdsConversionId?: string | null, googleAdsConversionLabel?: string | null, facebookPixelId?: string | null, mailchimpConnected: boolean, mailchimpAudienceName?: string | null, maxNumberOfPhoneNumbers: number, constantContactConnected: boolean, constantContactListName?: string | null, salesforceConnected: boolean, salesforceStageName?: string | null, salesforceContactRecordTypeName?: string | null, salesforceAccountRecordTypeName?: string | null, salesforceCampaignRecordTypeName?: string | null, salesforceOpportunityRecordTypeName?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, youtubeUrl?: string | null, emailSenderName?: string | null, emailSenderEmail?: string | null, doubleTheDonationConnected: boolean, doubleTheDonationPublicKey?: string | null, textToDonateEnabled: boolean, billingPlan: Types.BillingPlanName, address: { __typename?: 'NonprofitAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null }, facebookPage?: { __typename?: 'FacebookPage', id: string, name: string, profilePictureUrl: string } | null } };


export const WorkspaceDocument = /*#__PURE__*/ gql`
    query Workspace($id: ID!) {
  workspace(id: $id) {
    ...Workspace
  }
}
    ${WorkspaceFragmentDoc}`;

/**
 * __useWorkspaceQuery__
 *
 * To run a query within a React component, call `useWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceQuery, WorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, options);
      }
export function useWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceQuery, WorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, options);
        }
export function useWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceQuery, WorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, options);
        }
export type WorkspaceQueryHookResult = ReturnType<typeof useWorkspaceQuery>;
export type WorkspaceLazyQueryHookResult = ReturnType<typeof useWorkspaceLazyQuery>;
export type WorkspaceSuspenseQueryHookResult = ReturnType<typeof useWorkspaceSuspenseQuery>;
export function refetchWorkspaceQuery(variables: WorkspaceQueryVariables) {
      return { query: WorkspaceDocument, variables: variables }
    }